import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import Container from "@mui/material/Container";
import Button from "@mui/material/Button";
import MenuItem from "@mui/material/MenuItem";
import Logo from "../static/pol_log.png";
import { Link } from "react-router-dom";
import { darken } from "polished";

const pages = [
  { name: "Services", link: "/services" },
  { name: "Portfolio", link: "/portfolio" },
  { name: "About Us", link: "/about" },
  { name: "Schedule an Estimate", link: "/estimate" }
];

function MenuBar() {
  const [anchorElNav, setAnchorElNav] = React.useState(null);

  const handleOpenNavMenu = event => {
    setAnchorElNav(event.currentTarget);
  };
  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  return (
    <AppBar position="static" style={{ background: "#2E3B55" }}>
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          <Typography
            variant="h6"
            noWrap
            component={Link}
            to="/"
            sx={{
              mr: 2,
              display: { xs: "none", md: "flex" },
              fontFamily: "monospace",
              fontWeight: 700,
              letterSpacing: ".3rem",
              color: "inherit",
              textDecoration: "none",
              color: "#F5F5F4",
              transition: "color 0.3s",

              "&:hover": {
                color: darken(0.1, "#E4F0FF")
              }
            }}
          >
            <img
              style={{
                width: "120px",
                height: "52px"
              }}
              src={Logo}
            ></img>
          </Typography>

          <Box
            sx={{
              flexGrow: 1,
              display: { xs: "flex", md: "none" }
            }}
          >
            <IconButton
              size="large"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left"
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "left"
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: "block", md: "none" }
              }}
            >
              {pages.map(page => (
                <MenuItem
                  key={page.name}
                  component={Link}
                  to={page.link}
                  onClick={handleCloseNavMenu}
                >
                  <Typography textAlign="center">{page.name}</Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>
          <Typography
            variant="h5"
            noWrap
            component={Link}
            to="/"
            sx={{
              mr: 6,
              display: { xs: "flex", md: "none" },
              flexGrow: 1,
              fontFamily: "monospace",
              fontWeight: 700,
              letterSpacing: ".3rem",
              color: "inherit",
              textDecoration: "none",
              color: "#F5F5F4",
              transition: "color 0.3s",
              paddingTop: 1,
              paddingBottom: 1,
              "&:hover": {
                color: darken(0.1, "#E4F0FF")
              }
            }}
          >
            <img
              style={{
                width: "120px",
                height: "52px"
              }}
              src={Logo}
            ></img>
          </Typography>

          <Box
            sx={{
              flexGrow: 1,
              display: { xs: "none", md: "flex" }
            }}
          >
            {pages.map(page => (
              <Button
                key={page.name}
                component={Link}
                to={page.link}
                onClick={handleCloseNavMenu}
                sx={{ my: 2, mr: 1, color: "white", display: "block" }}
              >
                <Typography
                  sx={{
                    color: "#F5F5F4",
                    textTransform: "none",
                    transition: "color 0.3s",
                    "&:hover": {
                      color: darken(0.1, "#E4F0FF")
                    }
                  }}
                  textAlign="center"
                >
                  {page.name}
                </Typography>
              </Button>
            ))}
          </Box>
          <Box
            sx={{
              display: { xs: "none", md: "flex" },
              justifyContent: "right",
              alignContent: "right"
            }}
          >
            <Typography
              noWrap
              sx={{
                mr: 2,
                display: { xs: "none", md: "flex" },

                color: "#F5F5F4",

                "&:hover": {
                  color: darken(0.1, "#E4F0FF")
                }
              }}
            >
              Contact:
            </Typography>
          </Box>
          <Stack
            sx={{
              display: { xs: "none", md: "flex" },
              justifyContent: "right",
              alignContent: "right"
            }}
          >
            <Typography
              noWrap
              sx={{
                mr: 2,
                display: { xs: "none", md: "flex" },
                letterSpacing: ".12rem",
                color: "#F5F5F4",

                "&:hover": {
                  color: darken(0.1, "#E4F0FF")
                }
              }}
            >
              (732)-205-0086
            </Typography>
            <Typography
              noWrap
              sx={{
                mr: 2,
                display: { xs: "none", md: "flex" },
                letterSpacing: ".12rem",
                color: "#F5F5F4",

                "&:hover": {
                  color: darken(0.1, "#E4F0FF")
                }
              }}
            >
              (732)-525-8118
            </Typography>
          </Stack>
        </Toolbar>
      </Container>
    </AppBar>
  );
}
export default MenuBar;
